export default {
  // General
  'rt-previous-page': '上一頁',
  'rt-next-page': '下一頁',
  'rt-loadingText': '載入中',
  'rt-noDataText': '沒有數據',
  'rt-pageText': '頁',
  'rt-ofText': '共',
  'rt-rowsText': '行',
  'sms-verify':
    '為保障閣下會員權益，請點擊發送給閣下SMS中的連結確認登記電話號碼。若閣下收不到驗證SMS，請點擊以重新發送驗證訊息。',
  'email-verify-1':
    '為保障閣下會員權益，請點擊發送給閣下郵件中的連結確認登記電郵地址。',
  'email-verify-2':
    '郵件可能會被標記為垃圾郵件。如果我們的郵件被標記為垃圾郵件，閣下可以將 admin@datalouder.com 加入閣下的聯繫人列表以確保與我們的通訊順暢。閣下也可以發送郵件至 admin@datalouder.com 通過人工通道確認電郵地址。',
  'email-verify-button': '重新發送驗證郵件',
  'sms-verify-button': '重新發送驗證訊息',
  'email-verify-resent': '我們剛剛重新發送了一封認證郵件，請注意查收。',
  'sms-verify-resent': '我們剛剛重新發送了一封認證訊息，請注意查收。',
  Ok: '我知道了',
  'something-wrong': '抱歉，出現未知錯誤，請稍後重試。',
  Export: '導出',
  'wrong-password': '密碼錯誤',
  'too-many-attempts': '抱歉，閣下嘗試次數過多，請稍後重試。',
  'invalid-user': '用户不存在',
  'no-google-translate':
    '翻譯插件可能會影響網站的正常功能，請考慮使用網站右上角 EN/中 功能。',
  // Profile page
  'Update profile successful': '資料更新成功',
  // Payment ThankYou page
  'Thanks for subscribing Datalouder': '多謝你訂閱Datalouder!',
  'thankyou-page-redirect': '如果您的瀏覽器未能於10秒內重新導向，請您點擊此',
  'thankyou-page-link': '連結',
  // Nav bar
  Home: '首頁',
  Welcome: '歡迎',
  'DataLouder.com': 'DataLouder',
  DataLouder: 'DataLouder數據說話',
  Signals: '訊號',
  'US Signals': '美股訊號',
  'HK Signals': '港股訊號',
  Strategy: '韭菜策略',
  Ranking: '排行榜',
  Search: '搜索',
  Lookup: '查看股票',
  Tips: '專家貼士',
  'Tips List': '貼士總覽',
  'Stock Ranking': '股票排行',
  'Influencer Ranking': '誰是燈神',
  'Participant Ranking': '持股排行',
  'My Account': '我的帳號',
  Profile: '我的資料',
  'Membership & Payment': '會員和付款',
  'Log out': '登出',
  Register: '免費試用',
  'Verify Login': '驗證郵箱/電話',
  Login: '登入',
  Statistics: '排行榜',
  'US Statistics': '美股排行榜',
  'HK Statistics': '港股排行榜',
  'font-small': '小',
  'font-large': '大',
  'hk-stock': '港',
  'us-stock': '美',
  // updater
  'New version available': '有新的版本',
  'new version p 1': '我們定期推出新版本來提升您的使用體驗和添加新的功能。',
  'new version p 2':
    '您的客戶端版本過期，請點擊更新來獲取最新版本，這只會消耗一次刷新頁面的時間。',
  Update: '更新',
  Status: '系統狀態',
  // signals
  'Select Signal': '選擇訊號',
  'Inverted Hammer': '倒轉鎚頭',
  'Evening Star': '黃昏之星',
  'Bullish Engulfing': '向好吞噬',
  'Bearish Engulfing': '向淡吞噬',
  'Rising Sun': '曙光初現',
  'Dark Cloud Cover': '烏雲蓋頂',
  'Bullish Two Day Reversal': '向好雙日轉勢',
  'Bearish Two Day Reversal': '向淡雙日轉勢',
  'Three White Soldiers': '三白武士',
  'Three Dark Crows': '三飛烏鴉',
  'Morning Star': '早晨之星',
  Hammer: '鎚頭',
  'Black Candle': '陰燭',
  'White Candle': '陽燭',
  Viewer: '查看',
  signalOccurred: '相同信號出現',
  Occurences: '出現頻率',
  Probability: '升跌機率',
  'signal-click-to-view': '點擊一個數據點查看訊號股份。',
  '-': '（負）',
  bodyRelative: '燭身長度',
  'upperShadow / body': '上影線佔燭身長度',
  'lowerShadow / body': '下影線佔燭身長度',
  'lowerShadow / open': '下影線長度',
  'lowerShadow / wick': '下影線佔總波幅',
  'upperShadow / open': '上影線長度',
  'upperShadow / wick': '上影線佔總波幅',
  bodyRelativeBe1D: '前燭身長度',
  bodyRelativeBe2D: '二日前燭身長度',
  'wickBe1D / openBe1D': '總波幅 / 開盤價 （一日前）',
  // group
  'Group By': '選擇分類',
  All: '所有',
  Combined: '不分類',
  Deviation: '波動',
  'Relative Price (6 months)': '半年股價水平',
  'Relative Price (12 months)': '一年股價水平',
  Bluestacks: '藍籌股',
  'Market Cap': '市值',
  BollingerBand: '保力加通道',
  'Relative Strength Index': 'RSI',
  'Moving Average': '移動平均天線',
  'View group': '分類檢視',
  'Any value': '不選擇',
  '&&': '並且',
  'lowest quarter': '低位',
  'lower quarter': '中低位',
  'upper quarter': '中高位',
  'highest quarter': '高位',
  '<1T': '少於10億',
  '1T-5T': '10億至50億',
  '5T-30T': '50億至300億',
  '>30T': '大過300億',
  Bluestack: '藍籌股',
  'Bluestack-short': '藍籌',
  Others: '其他股票',
  // Occurence tab
  'Please select a signal.': '請選擇一個訊號。',
  'No data available': '很抱歉，沒有數據。',
  // Prob tab
  Day: '日',
  'Day (solid)': '參考價格 1（幾日前，實線）',
  'Day (dashed)': '參考價格 2（幾日前，虛線）',
  dashed: '虛線',
  solid: '實線',
  'smooth-select': '數據選項',
  'Smooth-cma': '平滑（置中移動平均）',
  'Smooth-sma': '平滑（簡單移動平均）',
  'Smooth-raw': '原始數據',
  smooth: '平滑數據',
  raw: '原始數據',
  // Signal occurence table
  'Stock Code': '股票代碼',
  'Stock Price': '股票價格',
  'Added Price': '添加價格',
  'Removed Price': '移除價格',
  'Added At': '添加於',
  'remove At': '移除於',
  'Change %': '變動率',
  High: '當日最高價',
  Low: '當日最低價',
  Open: '當日開盤價',
  Close: '當日收盤價',
  'close-or-now': '當日收盤價（或目前價格）',
  Volume: '當日成交量',
  // Zone
  'Stock Name': '股票名稱',
  // Ranking
  'stock-gain-loss': '股票漲跌',
  'industry-gain-loss': '工業漲跌',
  Mainboard: '主板',
  Gem: '創業板',
  'Updated on': '更新於',
  Price: '價格',
  Change: '變動',
  '% Change': '變動率',
  'Vol. / Avg ()': '成交量/%s平均',
  Turnover: '成交額',
  Mktcap: '市值',
  Concentration: '貨源集中比例',
  'Price Range': '價格水平',
  'Price Range Filter': '價格水平篩選',
  '* All CCASS data is 3 trading days old.':
    '* 所有 CCASS 數據為三個交易日前。',
  'Updated at': '最近刷新於',
  'showing data of %s': '顯示 %s 的數據',
  '1d': '1天',
  '3d': '3天',
  '5d': '5天',
  '1m': '1月',
  '2m': '2月',
  '3m': '3月',
  '6m': '6月',
  '1y': '1年',
  '52w': '52週',
  Vol: '成交量',
  Gain: '漲',
  Loss: '跌',
  'last-transaction-time': '最近成交時間',
  'show-category-label-btn': '顯示所有板塊',
  'reset-btn': '重置',
  'current-category': '正在顯示',
  'all-categories': '所有板塊',
  'one-month-data-available': '查看過去一個月數據',
  // price viewer
  noDataFetched: '沒有數據',
  nopDescription1: '藍線',
  nopDescription2: '：參與者數目，又稱散戶參與度或韭菜線',
  concentrationDescription1: '綠線',
  concentrationDescription2: '：貨源集中比例水平，又稱大戶參與度或大戶線',
  cryptoDescription: '所有加密貨幣皆以美元作單位',
  descriptionMore: '更多詳情',
  'Overlap volume with price': '成交量並列',
  'Overlap turnover with price': '成交額並列',
  nop1: '參數',
  nop2: '參數二',
  'Bollinger Band': '保力加通道',
  'fear-greed-index': '恐懼貪婪指數',
  southbound: '北水線',
  'aaii-bullish': '看漲指數',
  'aaii-bearish': '看跌指數',
  AAII: '散戶情緒指數',
  MACD: 'MACD',
  RSI: 'RSI',
  Fundamental: '基本面',
  PE: '市盈率',
  PB: '市帳率',
  'dividend-yield': '股息率',
  'short-ratio': '沽空比率',
  'retail-trades': '散戶盤路',
  'institutional-trades': '大戶盤路',
  'nop-strategy': '韭菜策略',
  'strategy-return': '策略回報',
  'strategy-signal': '策略狀態',
  'buy-signal': '買入訊號',
  'sell-signal': '沽空訊號（賣空)',
  'flat-long-position': '平倉信號',
  'close-position': '策略失效信號',
  bid: '賣',
  ask: '買',
  IndexSMA: '成分股市寬',
  MarketSMA: '整體市寬',
  opinion: '睇法',
  'expert-bullish': '在這天看好',
  'expert-bearish': '在這天看淡',
  'felt-bullish': '你在這天看好',
  'felt-bearish': '你在這天看淡',
  'not-felt-bullish': '在這天你不再看好',
  'not-felt-bearish': '在這天你不再看淡',
  d: '日',
  'No historical prices available': '找不到歷史數據',
  'The nearest (before) available summary is available on':
    '最近一次更新數據於',
  'symbol-period': '。',
  'No data is found.': '很抱歉，找不到數據。',
  high: '最高價',
  low: '最低價',
  open: '開盤價',
  close: '收盤價',
  volume: '成交量',
  amplitude: '波幅',
  max: '所有',
  'unit-minute': '分鐘',
  'unit-d': '日線',
  'unit-w': '週線',
  'unit-m': '月線',
  'minute-unit-1m': '1分',
  'minute-unit-3m': '3分',
  'minute-unit-5m': '5分',
  'minute-unit-15m': '15分',
  'minute-unit-1h': '小時',
  'minute-update-explain': '股票每分鐘價格於每日交易時間結束后更新',
  'nop-explain': 'CCASS+參與者數目的交易日期（參數二為公佈日期）',
  tags: '標簽',
  'shift-to-zoom-tip':
    '<bold>放大/縮小</bold> | 請按住 "shift" 鍵 + 滑鼠上下滑動',
  // CCASS
  Shareholding: '持股數量',
  'Shareholding Date': '持股日期',
  Summary: '概覽',
  'Shareholding in CCASS': '持股數量',
  'Number of Participants': '參與者數目',
  '% of the total number of Issued Shares/ Warrants/ Units': '已發行股份百分比',
  'Market Intermediaries': '市場中介者',
  'Consenting Investor Participants': '願意披露的投資者戶口持有人',
  'Non-consenting Investor Participants': '不願意披露的投資者戶口持有人',
  'Total CCASS': '存於 CCASS 的股份',
  'Securities not in CCASS': '不在 CCASS 的股份',
  'Total number of Issued Shares/Warrants/Units': '已發行股份',
  '(last updated figure)': '（最近更新的數據）',
  'N Change %': '參與者數目變化',
  'N Level': '參與者數目',
  'N Level Filter': '參與者數目篩選',
  'Concentration Level': '貨源集中比例水平',
  'Top N Concentration': '貨源集中比例（頭 N 位）',
  'Top N Concentration Change': '貨源集中比例變動（頭 N 位）',
  'Weighted Top N Concentration Change': '調整後頭 N 位貨源集中比例變動',
  'Compare Date': '參照日期',
  'Days Before': '天前',
  Customize: '自定',
  'compared to': '參照：',
  'previous-day': '上一個交易日',
  'Details of Market Intermediaries/Consenting Investor Participants':
    '市場中介者/願意披露的投資者戶口持有人詳細資料',
  Remarks: '說明',
  'view-full-page': '查看完整信息',
  'ccass-remark-1':
    '市場中介者包括非投資者戶口持有人的中央結算系統參與者。在特別情況下，個別市場中介者的股份結餘有機會出現負數，例如，市場中介者存入存管處的股票於過戶處重新登記時發現簽名不乎，結算公司會在市場中介者的戶口記除相關的股份數目直至市場中介者作出替換為止，在此期間，市場中介者的股份戶口有機會出現數天的負數。',
  'ccass-remark-2':
    '不願意披露投資者戶口持有人為不願意披露其持股紀錄的投資者戶口持有人。',
  'ccass-remark-3':
    '願意披露的投資者戶口持有人為願意披露其持股紀錄的投資戶口持有人。',
  'ccass-remark-4':
    '多種幣值上市的股份的持股紀錄是以每種幣值股份的持股量披露; 而每種幣值股份的已發行股份／認股權證／單位數目則是所有幣值股份的已發行股份／認股權證／單位數目之總和。每種幣值的已發行股本／認股權證／單位的百份比是根據所有幣值股份的已發行股份／認股權證／單位數目之總和計算。',
  'ccass-remark-5':
    '佔已發行股份／認股權證／單位的百份比是按最近更新的已發行股份／認股權證／單位計算，有機會沒有包括公司行動的資料或單位的新增及贖回，因此可能不是最新的。使用該百分比時敬請注意，該數值只作為參考之用，而由於除整的關係，個别參與者佔已發行股份／認股權證／單位的百分比的總和有機會不等於各自組別的總和及中央結算系統參與者總持股量的百分比的總和。',
  '% Share': '持股比例',
  'Share Change': '持股變動',
  'avg buy': '平均買入價',
  'avg sell': '平均賣出價',
  'avg trade': '平均成交價',
  'total change amount': '持股變動金額',
  'total change amount by day': '日總持股變動金額',
  'Name of CCASS Participant': 'CCASS 參與者名稱',
  'Share Holding Level': '持股數目(52週)',
  'Participant ID': '參與者 ID',
  'Holding Change': '持股變化',
  'Diff/Shares': '變動佔股本',
  Table: '表格',
  'other-participants': '其他參與者',
  'sharehold-distribution': '持股分佈',
  'buy-in-ranking': '買入排行榜',
  'sell-out-ranking': '賣出排行榜',
  // My Account
  'Basic Information': '基本資料',
  'Your name': '閣下的姓名',
  'Your public name': '公開名稱',
  'Email address or phone number': '電郵地址 或 電話 ',
  'Login placeholder': '例如：lewis@datalouder.com 或 +85269000755',
  Password: '密碼',
  'Retype Password': '再輸入新密碼',
  // Footer
  Version: '版本',
  'Contact Us': '聯繫我們',
  'Term of Service': '使用條款',
  Disclaimer: '免責聲明',
  Copyright: '版權聲明',
  'Privacy Policy': '隱私條款',
  // Payment
  'No record.': '沒有找到交易歷史。',
  Date: '日期',
  Amount: '金額',
  Detail: '說明',
  Verified: '已確認',
  Received: '已收到',
  Pending: '等待確認',
  Transactions: '交易',
  'almost-join-us':
    '閣下目前正在使用基本計劃，購買專業計劃即可享受所有功能，全面提升交易水平。',
  'promo-free-month': '現在註冊將獲贈一個月的免費會員。',
  'payment-success':
    '我們正在核實並更新訂閱狀態，刷新此頁以查看最新狀況。此頁面亦會在一分鐘後自動刷新。',
  'membership-remain': '謝謝成為我們的會員！閣下的會員計劃還有',
  'avg-day-payment': '平均每日花費為 HKD',
  'charge-time-for-free-trial': '十日免費試用期内不會收取費用',
  Membership: '會員計劃',
  days: '天',
  Item: '項目',
  Number: '數量',
  'Free Month Bonus': '一個月免費會員',
  'Equal to': '相當於',
  Total: '總共',
  '/ Month': '每月',
  discount: '折扣',
  'renew-it': '延長會員計劃',
  'select-renew-options': '請選擇延長會員的期限：',
  paypal: 'PayPal',
  'paypal-subscription': 'PayPal 訂閱',
  'other-payment-methods': '查看更多支付方式',
  'recurring-payment':
    '此為訂閱服務，當閣下會員到期，並且沒有取消會員訂閱時，我們將將再次收取相同費用並延長閣下的會員計劃。',
  'promo-code': '優惠代碼:',
  apply: '應用',
  'have-applied': '閣下已使用優惠計劃 「{{title}}」。',
  'invalid-promo': '閣下使用的優惠代碼 "{{code}}" 無效。',
  Promo: '優惠後',
  'may-be-delayed': '此信息可能有延遲',
  'cannot-find-subscription': '沒有找到閣下有訂閲記錄',
  'subscription-id': '訂閲 ID',
  'subscription-status': '訂閲狀態',
  'subscription-status-ACTIVE': '訂閲中',
  'subscription-status-SUSPENDED': '自動扣費暫停',
  'subscription-status-APPROVAL_PENDING': '等待用戶批准',
  'subscription-status-CANCELLED': '已取消',
  'subscription-status-CANCELED': '已取消', // stripe only
  'subscription-status-TRIALING': '訂閲中', // stripe only, text same as "active" due to subscription extension has trialing status
  'subscription-status-PAST_DUE': '已逾期', // stripe only
  'subscription-status-UNPAID': '未繳付', // stripe only
  'subscription-status-INCOMPLETE': '未完成', // stripe only
  'subscription-status-INCOMPLETE_EXPIRED': '未完成已過期', // stripe only
  'next-bill-date': '下次扣費日期（僅訂閱中）',
  'extend-subscription': '延長訂閲',
  'switch-to-stripe-subscription': '轉換為 Stripe 訂閲',
  'approve-subscription': '批准訂閱',
  'approve-subscription-reason': `您僅差一步！我們正在將您重定向到PayPal以完成您的訂閱設定。請按照PayPal頁面上的指示來批准您的訂閱。您的訂閱狀態目前為“待批准”，一旦您完成此步驟，它將被激活。`,
  'approve-subscription-button': '跳轉至 PayPal',
  'cancel-subscription': '取消訂閲',
  'confirm-cancel-subscription':
    '閣下是否打算取消會員訂閲？如果閣下仍在試用，取消訂閱會立即中終試用計劃，敬請留意。',
  'subscription-cancelled': '已收到閣下會員訂閲請求。',
  Subscriptions: '會員訂閱',
  Approve: '批准此訂閱',
  'one-time-payment': '一次性購買',
  'use-stripe': '我想使用 Stripe 付款',
  'subscription-summary-existing':
    '閣下已有訂閱將於 <bold>{{nextBillTime}}</bold> 結束並使用 Stripe 自訂續訂，每<bold>{{cadence}}</bold>續訂一次，續訂費用為 <bold>{{price}}</bold> HKD。',
  'subscription-summary-new':
    '成功一次性購買<bold>{{extendDuration}}</bold>會員之後，新的訂閱將於 <bold>{{nextBillTime}}</bold> 結束並使用 Stripe 自訂續訂，每<bold>{{cadence}}</bold>續訂一次，續訂費用為 <bold>{{price}}</bold> HKD。最多只能延長至 2 年。',
  'manual-summary':
    '閣下會員將於 <bold>{{nextBillTime}}</bold> 結束，目前沒有訂閱。',
  'subscription-switch-summary':
    '我們將跳轉至 Stripe 網站，閣下將會被要求輸入信用卡信息或 Stripe 帳號設置 Stripe 訂閱。<bold>此次操作不會有任何扣費付款，閣下剩餘會員 ({{remainingDays}}天) 將會轉為試用期</bold>。第一次付款將在 <bold>{{nextBillTime}}</bold> 之後。轉換操作中無法使用優惠碼，但成功轉換為 Stripe訂閱後，閣下將可以使用"延長訂閱"功能延長訂閱，屆時閣下可使用優惠碼。',
  'whatsapp-us-if-you-have-any-questions':
    '如果有任何問題請通過 WhatsApp 聯繫我們: <link />',
  'cadence-1month': '一個月',
  'cadence-6month': '六個月',
  'cadence-12month': '一年',
  'checking-out': '已跳轉至付款介面，付款成功後請刷新此頁面。',
  'click-to-redirect-if-not': '點擊這裡如果付款介面無法跳轉',
  'setting-up-subscription':
    '已跳轉至 Stripe 訂閱介面，設置成功後請刷新此頁面。',
  // Plan cards
  'plan-basic-title': '基本',
  'plan-basic-subtitle': '無需付費, 探索 DataLouder各樣功能 ',
  'plan-basic-price': '免費',
  'plan-pro-title': '專業',
  'plan-pro-subtitle': '所有指標及圖表，全方位提昇交易水平',
  'plan-pro-1m': '一月',
  'plan-pro-6m': '半年',
  'plan-pro-12m': '一年',
  'pay-every-1m': '每月付款',
  'pay-every-6m': '每半年付款',
  'pay-every-12m': '每年付款',
  'buy-6m-cheaper': '節省$1,299.95!',
  'buy-1y-cheaper': '節省$3,299.89!',
  'plan-pro-free-trial': '首十日免費試用!',
  'each-user-only-one-time-free-trial':
    '每個用戶只能有1次免費試用，前會員將無法再使用此優惠! 如有欵問可以向我們查詢',
  'stripe-checkout-button-text': '帳戶 或扣帳卡信用卡',
  // Register
  'i-know-and-agree': '我了解並同意',
  and: '和',
  'register-failed': '註冊失敗。如果閣下已經是我們的用戶，請登錄或者重設密碼。',
  'invalid-country-code': '請輸入您的手機國家代碼 例如香港: +852',
  'duplicated-email': '您的電郵已被註冊或電郵地址不正確',
  'duplicated-username': '您的用户名稱已被使用',
  // Home
  'Join Now': '現在加入',
  // Email Verify Page
  'evp-title': '會員帳號認證',
  'evp-body': '您的會員帳號認證成功，謝謝！',
  // Copyright
  'All Rights Reserved.': '保留所有權利。',
  // system status
  Task: '進程',
  'Current State': '目前狀態',
  'Updated At': '更新時間',
  HKT: '香港時間',
  // table
  'BS-short': '藍',
  'Gem-short': '創',
  'stock-type-us': '🇺🇸',
  'stock-type-hk': '🇭🇰',
  'stock-type-crypto': '幣', // to support legacy stock type
  'stock-type-crpt': '幣',
  'stock-type-crptbn': '幣',
  'stock-type-otc': 'OTC',
  // ResetpasswordPage
  'Reset Password': '重置密碼',
  'Send Verification Code': '發送驗證代碼',
  'reset-code-incorrect': '驗證代碼錯誤',
  'invalid-phone-num': '此號碼非有效電話號碼',
  'not-support-country': '你的電話國家代碼暫時不支援。',
  'too-many-request': '請等60秒再按一次',
  'bad-request': '系統監測到錯誤的指令',
  'password-reset-success': '閣下的密碼已經重置，請重新登錄。',
  'Verification Code': '驗證碼',
  'Verification code is required.': '驗證碼是必填的。',
  'Re-enter effective phone number or email address':
    '重新輸入有效電話或電郵地址',
  Submit: '提交',
  // loginPage
  'Log in': '登錄',
  "I don't have an account": '我暫時沒有帳號',
  'forget password?': '忘記密碼？',
  'login-block-warning':
    '用户每小時只有10次嘗試登入的機會，如超過了會被短暫封鎖1小時',
  Remember: '記住我的登錄',
  'Login is required.': '電話或電郵是必填的。',
  'Password is required.': '密碼是必填的。',
  // register Page
  'How you want us to call you?': '我們該如何稱呼閣下？',
  'Public name will be used in watching list': '在用户觀察名單上會顯示這名稱',
  'Name is required.': '暱稱是必填的。',
  'Public Name is required': '公開名稱是必填的。',
  'email-placeholder':
    '輸入閣下的電子郵件，我們保證不會未經允許向第三方披露此地址。',
  'Please retype your password.': '兩次輸入的密碼不一致，請重新輸入',
  'I already have an account': '我已有 Datalouder 的帳戶',
  // stock page
  statistics: '數據',
  'recent-month': '最近一月',
  'expert-views': '專家睇法',
  strategy: '策略',
  'stock-not-found': '抱歉我們沒有在數據庫中找到這支股票。',
  'input-stock-name-or-code': '輸入股份代號或者名稱',
  'related-statistics': '相關類別統計',
  ixic_price_trading_view: 'IXIC 報價暫時由 TradingView 顯示',
  click_to_view_detail: '點擊查看',
  // stock stragtehy
  n_trades: '買賣次數',
  win_rate: '勝率',
  mean_annual_return: '平均年回報率',
  max_drawdown_rate: '最大回徹',
  calmar_ratio: '卡瑪比率',
  sharpe_ratio: '夏普值',
  sharpe_ratio_SH: '一直持有夏普值',
  total_return: '總收益',
  total_return_SH: '一直持有總收益',
  // Admin
  Admin: '管理',
  Name: '姓名',
  Users: '用戶',
  'Email Records': '電郵紀錄',
  'Sent At': '發送於',
  Email: '電郵',
  Phone: '電話',
  Subject: '主題',
  View: '查看',
  'Registered On': '註冊時間',
  register: '註冊',
  subscribe: '訂閱',
  'subscribe-member': '訂閱會員',
  'last-used-time': '最新使用時間',
  ID: 'ID',
  Title: '標題',
  'Video ID': '視頻 ID',
  Edit: '編輯',
  Add: '增加',
  Cancel: '取消',
  enabled: '可用',
  'used-time': '使用次數',
  'task-id': '任務 ID',
  'task-name': '任務名稱',
  'job-id': '執行 ID',
  'cron-expression': '定時表達式',
  timezone: '時區',
  'targeted-at': '預計執行時間',
  status: '最新狀態',
  params: '執行參數',
  Tasks: '任務',
  Jobs: '任務執行',
  'Restart Job': '重啟任務',
  'Restart Daemon': '重啓進程',
  'Restart Realtime Daemon': '重啓實時股票抓取進程',
  'Restart Backend Daemon': '重啓服務器後端進程',
  'Restart CMS Daemon': '重啓 Strapi CMS 進程',
  'Restart MySQL Daemon': '重啓數據庫進程',
  Financial: '財務',
  PromoCodeUsage: '優惠代碼使用情況',
  ManageStockTag: '管理股票標籤',
  UserId: 'User Id',
  PromoCode: '優惠代碼',
  PaidAmount: '繳交費用',
  PaidDate: '繳費日子',
  Audit: '審計',
  'monthly-table': '月份報表',
  Month: '月份',
  Income: '進帳',
  Refund: '退款',
  Revenue: '收入',
  // task names
  DailyPrice: '更新股票價格',
  CCASS: '更新 CCASS',
  GroupDeviation: '分組訊號 (波動)',
  GroupRP180: '分組訊號 (半年股價水平)',
  GroupRP360: '分組訊號 (一年股價水平)',
  Signal: '檢測訊號',
  GroupNone: '分組訊號 (不分組)',
  ProbNone: '計算概率 (不分組)',
  ProbDev: '計算概率 (波動)',
  ProbRP180: '計算概率 (半年股價水平)',
  ProbRP360: '計算概率 (一年股價水平)',
  ProbBS: '計算概率 (藍籌)',
  GroupSMA: '分組訊號 (SMA)',
  DayMap: '檢測日期關係',
  GroupMktcap: '分組訊號 (市值)',
  ProbMktcap: '計算概率 (市值)',
  ProbSMA10: '計算概率 (SMA10)',
  ProbSMA20: '計算概率 (SMA20)',
  ProbSMA50: '計算概率 (SMA50)',
  ProbSMA250: '計算概率 (SMA250)',
  GroupBB: '分組訊號 (BB)',
  GroupRSI: '分組訊號 (RSI)',
  ProbBB: '計算概率 (BB)',
  ProbRSI: '計算概率 (RSI)',
  GroupEMA: '分組訊號 (EMA)',
  ProbEMA10: '計算概率 (EMA10)',
  ProbEMA20: '計算概率 (EMA20)',
  ProbEMA50: '計算概率 (EMA50)',
  ProbEMA250: '計算概率 (EMA250)',
  MinuteData: '更新當日分鐘價格',
  UsersWinPercentage: '用戶回報及勝率',
  InfluencersWinPercentage: '專家回報及勝率',
  ConsituentSMA: '市寬',
  DailyPrice_2: '更新股票價格 (指數)',
  MarketZones: '價格分區',

  // histogram
  'yellow-ma': '黃線為升跌比例5天移動平均',
  inx: '標準普爾500指數',
  gspc: '標準普爾500指數',
  dji: '道瓊斯工業平均指數',
  hstech: '恒生科技指數',
  ixic: 'IXIC 指數',
  hsi: '恒生指數',
  bitcoin: 'Bitcoin',
  btc: 'Bitcoin',
  // new badge
  'new-badge': '新!',
  'new-badge-feature': '新功能!',
  'new-badge-content': '新內容!',
  // fav stock
  'fav-stock': '我的觀察名單',
  'others-fav-stock': '其他人的觀察名單',
  'fav-stock-display': '顯示觀察名單',
  'show-fav-stock-display': '顯示觀察名單',
  'hide-fav-stock-display': '隱藏觀察名單',
  'win-percentage-note':
    '回報率及勝率由閣下於2021-01-21(最新版本發布日期)或以後加入觀察名單之股票計算而成。美股和加密貨幣暫時合併計算。',
  'fav-history': '觀察歷史',
  'fav-list': '觀察清單',
  'his-fav-stock': '他（她）的自選股票',
  'no-fav-stocks': '閣下目前未有自選股票',
  'no-fav-history': '閣下目前未有觀察歷史',
  'earning-%': '回報率',
  'win-rate': '勝率',
  'win-overview': '綜合表現',
  'win-analyse-HK': '港股觀察名單表現',
  'win-analyse-US': '美股觀察名單表現',
  'win-analyse-CRPT': '加密貨幣觀察名單表現',
  'added-fav-stock-at': '添加於 {{deltaTime}}',
  // dashboard
  'Edit Profile': '編輯資料',
  'You have been with us for': '閣下已經加入數據說話',
  'peek-profile': '下面是閣下的一些基本信息：',
  // hkex profile
  Industry: '行業',
  'Listing Date': '上市日期',
  'Financial Year Ends': '財政年度結算日期',
  Chairman: '主席',
  'Principal Office': '總辦事處',
  'Place of Incorporation': '註冊地點',
  'Listing Category': '上市類型',
  Registrar: '過戶處',
  'as at': '截至',
  'company-intro': '公司簡介',
  'Shares outstanding': '流通股',
  'PE Ratio': '市盈率',
  Beta: '啤打系數',
  'Gross Profit': '毛利',
  'Total Revenue': '總收入',
  'Net Income': '淨收入',
  'Current Assets': '當前資產',
  'Total Assets': '總資產',
  'Total Liabilities': '負債總額',
  'Current Cash': '流動現金',
  'Current Debt': '當前債務',
  'Total Cash': '總現金',
  'Total Debt': '總債務',
  'Cash Flow': '現金周轉',
  // hkex news
  'company-news': '最近新聞',
  'release-time': '發佈時間',
  content: '內容',
  'scanned-every-hour': '每小時更新一次',
  'scanned-5-min': '每 5 分鐘更新一次',
  'load-more': '載入更多新聞',
  // public profile
  'no-permission-to-view': '抱歉，閣下沒有足夠權限查看。',
  // configure profile permission
  'public-profile-permission': '檔案隱私設置',
  'permission-private': '僅我自己可見',
  'permission-public': '付費用戶可見',
  'your-permission-url-is': '閣下的公開頁面為',
  'public-alias': '公開暱稱',
  'duplicate-name-alert': '此名稱已被使用',
  'empty-name-alert': '請輸入名稱',
  // color style
  'color-style': '網頁顏色設置',
  'graph-color-style': '陰陽燭顏色',
  'nop-color-style': '韭菜線(參與者數目)顏色',
  'ccass-title': '韭菜線(參與者數目)',
  ccass: '韭菜線',
  'concentration-color-style': '貨源集中比例水平顏色',
  'comparison-color-style': '比較股票顏色',
  'graph-up': '陽',
  'graph-down': '陰',
  // strategy setting
  'strategy setting': '韭菜策略模式設置',
  'backtest-mode': '回測模式',
  'simple-mode': '簡易模式',
  'mode-selection': '模式選擇',
  'backtest-mode-info':
    '回測模式 : 將會更詳細顯示期間回報及 Forward test 等資料',
  'simple-mode-info': '簡易模式 : 以最佳用戶體驗顯示策略資料',
  // free user
  'purchase-vip-to-unlock-all': '購買會員即可解鎖所有功能',
  'feature-requires-vip': '此功能免費用戶暫不可用',
  'you-need-to-pay-to-unlock': '購買會員即可解鎖 ',
  Purchase: '購買',
  DEMO: '演示',
  'and-enable-realtime-view': '（包括實時排行榜）',
  'know-more': '了解更多',
  'register-to-see-more': '免費登記成為會員查看更多資訊',
  // feature name
  'feature-ratio': '查看歷史漲跌比例圖',
  'feature-bubble': '查看板塊升跌圖',
  'feature-date-navigator': '查看歷史數據',
  'feature-PriceViewer': '價格查看器',
  'feature-VIPTradeIdeas': 'VIP 文字交流',
  'feature-Zone': '價格分區',
  'feature-CCASSTable': 'CCASS+ 信息查看器',
  'feature-HKEXNewsViewer': 'HKEX 新聞查看器',
  'feature-private-stocklist': '自選股票隱私設置',
  'feature-stocklist': `查看其他用戶自選股票`,
  'buy-vip': '購買會員',
  // user stock list
  'usl-stock-view-user-title': '關注這隻股票的用家',
  'usl-stock-view-nouserlike-title': '沒有用家關注這隻股票',
  'usl-member': '會員',
  'usl-free': '試用用戶',
  'usl-select': '共享關注',
  'usl-you-are-viewing': '閣下正在查看 <u>{{name}}</u> 的自選列表',
  'usl-go-back': '顯示所有股票',
  'usl-explain': `付費用戶可以選擇公開自選列表。<br />免費用戶自選列表將保持公開。`,
  'usl-explain1': '選擇一個用戶查看他（她）關注的股票',
  'more-like': '還有 {{n}} 匿名用戶喜歡該股票。',
  'more-unlike': '還有 {{n}} 匿名用戶不喜歡該股票。',
  'usl-not-found': '未有此用户',
  // incidents
  oops: '抱歉 DataLouder 發生了一些意外⋯⋯',
  'issue-reported':
    '這個狀況已經上報至開發團隊，如果閣下有疑問，請聯繫我們並且附上此代碼/二維碼 <b>{{eventId}}</b>。',
  'your-browser-is-too-old':
    '我們很抱歉造成您的不便，但看起來您目前使用的瀏覽器版本與我們的網頁應用程式不兼容，導致了意外的問題。為了確保您獲得最佳且最安全的體驗，我們建議您將瀏覽器升級至最新版本，或考慮使用其他已更新的瀏覽器。',
  // shortkeys
  Shortkeys: '快捷鍵 (?)',
  'Shortkeys-modal': '當前可用快捷鍵',
  'shortkey-section-global': '全局快捷鍵',
  'view-shortkeys': '查看可用快捷鍵',
  'go-to-lookup': '打開「查看股票」',
  'go-to-ccass': '打開「CCASS+」',
  'go-to-signal': '打開「訊號」',
  'go-to-ranking': '打開「排行榜」',
  'show-help-buttons': '顯示幫助按鈕',
  'shortkey-section-table': '股票列表快捷鍵',
  'previous-stock': '查看上支股票',
  'previous-stock-5': '跳過查看之前第五支股票',
  'next-stock': '查看下支股票',
  'next-stock-5': '跳過查看之後第五支股票',
  'shortkey-section-peek': '股票快捷鍵',
  'add-remove-favorite': '從我的喜歡股票中加入/移出',
  'add-remove-isUnlike': '從我的不喜歡股票中加入/移出',
  'shortkey-section-admin': '管理員快捷鍵',
  'toggle-payment-view': '切換付款介面',
  // notification
  'notification-center': '消息中心',
  'notification-popup-checkbox': '不再彈岀此視窗',
  'post-category-release': '版本變更',
  'post-category-tutorial': '教程',
  'post-category-news': '新聞',
  Unreleased: '未發布',
  Empty: '目前沒有消息',
  Unread: '未讀',
  // Tutorials
  'videos-and-tutorial': '視頻與教學',
  tutorial: '教學視頻',
  tutorials: '教學',
  Tutorials: '教學文檔',
  Videos: '示範片段',
  'show-question-buttons': '顯示提示按鈕',
  'hide-question-buttons': '隱藏提示按鈕',
  'more-tutorials': '更多教學文檔',
  'course-menu': '課程',
  'free-seminars': '免費入門班',
  course: '大數據趨勢交易課程(1月班)',
  'trading-course': '交易課程',
  'advanced-course': '進階課程',
  // Tips
  'local-time': '本地時間',
  'tips-create': '創建記錄',
  'tips-submit': '提交',
  'tips-reset': '重置',
  influencer: '專家',
  'influencer-rank': '排行',
  'influencer-score': '專家分數',
  'influencer-result': '專家成績',
  'influencer-count': '貼士數目',
  'stock-code': '股票代號',
  'create-tips-modal-title': '創建紀錄',
  'edit-tips-modal-title': '修改紀錄',
  direction: '方向',
  'tips-date': '預測時間 (GMT +8)',
  'created-at': '創建時間 (GMT +8)',
  'created-by': '創建者',
  'tips-status': '狀態',
  'edit-tips-button': '修改',
  'doubt-tips-button': '質疑',
  'tips-verify': '審核',
  'verify-tips-button': '證實',
  'delete-tips-button': '不實',
  'tips-price': '預測時價格',
  'key-comment': '意見節錄',
  channel: '渠道',
  'source-link': '超鏈結來源',
  'tips-return': '平均回報',
  'tips-return-till-now': '回報 (至今)',
  'tips-win-analyse-hk': '港股貼士表現',
  'tips-win-analyse-us': '美股貼士表現',
  'tips-history': '預測歷史',
  'stock-no-tips-history': '此股票暫無專家預測',
  'no-tips-history-hk': '此專家於港股暫無預測',
  'no-tips-history-us': '此專家於美股暫無預測',
  'tips-win-percentage-note':
    '貼士表現反映歷史預測之平均回報率及平均勝率，如專家少於7則歷史預測則不會計算',
  'tips-bullish': '睇好',
  'tips-bearish': '睇淡',
  'tips-error': '錯誤:',
  'tips-error-required': '錯誤: 必填 - ',
  'tips-choose-influencer-from-list': '從建議列表選擇專家，或輸入新的專家名稱',
  'tips-choose-stockCode-from-list': '從建議列表選擇股份代號',
  'tips-choose-direction': '選擇預測方向',
  'tips-obtain-price': '從建議列表選擇股份代號以獲取報價',
  'tips-no-future-date': '不允許輸入未來時間',
  'tips-insert-channel': '輸入資源來源平台名稱',
  'tips-insert-link': '輸入資源來源鏈結',
  'tips-insert-keyword': '輸入關鍵字句',
  'tips-create-tips-principle':
    '注意: 以能跟隨該意見交易為大前提，當專家持有明確方向意見，便值得紀錄',
  'tips-status-V': '已驗證',
  'tips-status-A': '已驗證 (自動)',
  'tips-status-Q': '準確性存疑 (自動)',
  'tips-status-D': '審核中',
  'tips-status-X': '不準確',
  'tips-status-default': '已提交',
  // RangeSlider
  'close-popup': '收起',
  // global Alerts
  UserTokenInvalid: '閣下登錄信息過期，請重新登錄。',
  BadGateway:
    'DataLouder 正在更新，通常十秒鐘恢復正常。如果閣下持續看見此信息，請聯繫我們。',
  // user configurable alarms
  Alarms: '提醒',
  'New Alarm': '新建提醒',
  GE: '達到',
  LE: '跌至',
  create: '創建',
  comparisonStock: '比較股票',
  // General error
  'unknown-error': '未知錯誤',
  invalidDate: '日期錯誤',
  // SEO title and description
  'seo-title-Home': '股市數據回測平台｜大數據監察股市 讓交易更有把握',
  'seo-title-Signals': '獨家風險訊號功能｜避開突如其來股災',
  'seo-title-Ranking': '全功能排行榜｜輕鬆選出倍升股',
  'seo-title-Tips': '監察股市專家｜真假財演一眼睇穿',
  'seo-title-Lookup': '大戶散戶盤路｜助你發掘翌日爆升機會',
  'seo-title-CCASS': '獨家 CCASS+｜監察貨源集中程度及監察大戶/散戶倉位',
  'seo-description-Home':
    'DataLouder為股票交易者提供專業財經資訊，運用大數據對市場資訊進行分析，為用戶增加交易分析優勢。以客觀數據代替主觀判斷，提升投資回報及交易表現。',
  'seo-description-Signals':
    '獨家訊號回測功能，一鍵回測常見圖表形態，直接分析升跌機率。獨家原創「四色八線圖」助股民更容易解讀大市風險，避開危機。',
  'seo-description-Ranking':
    '想要尋找強勢股，卻不知道從何入手嗎？排行榜為你一秒搜羅港股美股強弱股。',
  'seo-description-Tips':
    '以大數據分方式記錄財經機構及專家對股市的看法，以直觀圖表自動計算準勝度、回報率，細緻呈現專家表現。',
  'seo-description-Lookup':
    '即日統計全日盤路，分析大戶散戶買賣盤，助你捉緊大戶步伐，快人一預先部署。',
  'seo-description-CCASS':
    '多角度審視貨源集中程度及監察大戶/散戶倉位，全面透視各間證券行持貨比例。',
  // Help
  'articles-in-same-category': '此類別內的文章',
  Help: '教學資源',
  // 3rd party login
  'continue-with-fb': '用 Facebook 登錄',
  'continue-with-google': '用 Google 登錄',
  'retry-login': '嘗試用其他方式登錄',
  // fb login
  'fb-error-user_denied': '授權失敗',
  // whatsapp channel
  'trading-squad': '高手圈',
  'trading-squad-setting': '高手圈設置',
  'click-to-trading-squad-setting': '按此前往高手圈設定',
  'members-only': 'VIP會員限定',
  'see-the-market-trend-in-10-mins': '10分鐘 掌握大市走勢',
  'whatsapp-channel-description':
    '更快收到 DataLouder 數據，令你 10分鐘掌握大市走勢，數據說話，事實為本。',
  'whatsapp-channel-status': '狀況',
  processing: '處理中',
  deleted: '已移除',
  problem: '有問題',
  joined: '已加入',
  unconnected: '未加入',
  'questions-contact-us': '有疑問？聯絡我們',
  'join-now': '成為會員',
  'join-whatsapp-channel': '加入 WhatsApp Channel',
  'update-whatsapp-number': '更改號碼',
  'enter-whatsapp-number': '請輸入 WhatsApp 電話號碼',
  please: '請',
  confirm: '確認',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  input: '輸入',
  ok: '確定',
  end: '完成',
  'home-page': '主頁',
  'whatsapp-channel-register': '高手圈註冊',
  'whatsapp-channel-register-sm': '高手圈',
  'whatsapp-number': 'WhatsApp 電話號碼',
  'received-request': '已收到加入 ’高手圈’ 的要求',
  'received-update-request': '已收到’更新號碼’的要求',
  'congratulation-text':
    '<span>請留意WhatsApp，3個工作天內</span><br/><span>會成功加入WhatsApp Channel</span>',
  'join-now-description': '成為會員',
  'whatsapp-faq-title-1': '可以單獨付費加入 ’高手圈’ 嗎？',
  'whatsapp-faq-title-2': '內容是什麼？',
  'whatsapp-faq-title-3': '’高手圈’ 適合新手嗎？',
  'whatsapp-faq-title-4': '什麼人可以加入 ’高手圈’ ？',
  'whatsapp-faq-title-5': '加入流程',
  'whatsapp-faq-title-6': '技術支援和客戶服務',
  'whatsapp-faq-description-1':
    '暫時未能單獨付費加入 ’高手圈’ ，只開放給付費會員。<br/>我們的產品務求用戶會融合高手圈的內容，網站股票數據，以及自己的交易策略來作出理性的分析。<br/>加入會員: <a href="https://datalouder.com/payment" target="_blank">點擊這裡</a>',
  'whatsapp-faq-description-2':
    '<ul class="info"> <li>Datalouder 每日數據分析結果: 令你10分鐘掌握大市走勢</li> <li>最新網站功能通知：令你更快，更精準分析大量數據，把握交易機會，減低風險</li> <li>最新消息：不會錯過任何對股票市場有用的新聞及消息</li></ul>',
  'whatsapp-faq-description-3':
    '<ul class="info"> <li>高手圈適合任何人，無論你是新手還是老手，可以從 ‘高手圈’ 中獲得新消息，Datalouder 數據分析結果，幫助交易路更平坦。</li></ul>',
  'whatsapp-faq-description-4':
    '<ul class="info"><li>相信數據，理性分析</li><li>想接收最新市場消息</li><li>想改變愈撈愈低，未試過正回報的壞習慣</li><li>想發掘爆升機會</li></ul>',
  'whatsapp-faq-description-5':
    '加入流程<br/><ol class="info"><li>輸入Whatsapp 電話號碼</li><li>確認</li><li>3 個工作天內，專人處理</li><li>成功加入 `Datalouder 百倍升空計劃` Channel</li></ol>',
  'whatsapp-faq-description-6':
    '<ul class="info"><li>如果用戶遇到技術問題或有其他查詢，請聯絡我們: <a href="https://api.whatsapp.com/send?phone=85269000755" target="_blank">+852 69000755</a></li></ul>',
  // whatsapp channel admin page
  'expire-at': 'Plan 結束日期',
  request: '請求',
  'new-request': '新請求',
  'update-request': '更新資料',
  'remind-request': '提醒',
  'delete-request': '刪除',
  'done-false': '未完成',
  'done-true': '完成',
  remark: '備註',
  'staff-remark': '內部備註',
  'update-time': '更新時間',
  'create-time': '創建時間',
};
